const peopleReflow = () => {
  let card = document.querySelector('.card');
  let grid = document.querySelector('.grid');

  let cards = $('.card:not(.static)');
  let cardsVisible = $('.card:visible');

  let drawers = $('.person-drawer');

  if (grid && card) {
    cards.removeClass('start');
    drawers.find('.collapse').removeClass('show');

    $('.card-person').addClass('collapsed');
    $('.person-drawer').find('.collapse').removeClass('show');

    let colWidth = $('.card:visible').width();
    let gridWidth = $('.grid').width();
    let totalCols = Math.floor(gridWidth / colWidth);

    cardsVisible.each(function(i) {
      if (i % totalCols == 0) {
        if ( i != 0 ) {
          $(this).addClass('start');
        }
      }
    })

    drawers.each(function() {
      $(this).css('grid-column-start', 'span ' + totalCols);
    });

    $('.grid .person-drawer').detach().appendTo('.drawers-staging').removeClass('show');

    $('.drawers-staging .collapse').on('show.bs.collapse', function (e) {
      let $trigger = $('.card-person[data-target="#' + $(e.target).attr('id') + '"]');
      let $target = $(e.target).parent();
      let $nextRow = $($trigger.parent().nextAll('.card.start').first());

      $target.insertBefore($nextRow);
    });

    $('.drawers-staging .collapse').on('hidden.bs.collapse', function () {
      $(this).parent().detach().appendTo('.drawers-staging');
    });
  }
};

const peopleFilter = () => {
  const filterOptions = document.querySelectorAll('.btn-filter-option');

  filterOptions.forEach(function (el) {
    el.addEventListener('click', function () {
      const currentActiveFilter = document.querySelector('.btn-filter-option.active');
      currentActiveFilter.classList.remove('active');
      this.classList.add('active');

      const peopleAndDrawers = $('#people-grid').children();

      peopleAndDrawers.each(function() {
        $(this).show();

        if ($(this).data('category') != $('.btn-filter-option.active').data('filter')) {
          $(this).hide();
        }
      });

      if($('.btn-filter-option.active').data('filter') === 'people-grid') {
        peopleAndDrawers.show();
      }

      peopleReflow();
    });
  });
};

export { peopleReflow, peopleFilter };



// WEBPACK FOOTER //
// ./scripts/people.js